import { render, staticRenderFns } from "./ContentColumnModal.vue?vue&type=template&id=34d572c6&scoped=true&"
import script from "./ContentColumnModal.vue?vue&type=script&lang=js&"
export * from "./ContentColumnModal.vue?vue&type=script&lang=js&"
import style0 from "./ContentColumnModal.vue?vue&type=style&index=0&id=34d572c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d572c6",
  null
  
)

export default component.exports